import {
  ADD_NOTIFICATION,
  CLEAR_NOTIFICATIONS,
  SET_SERVER_ERROR,
  UPDATE_QUERY,
} from '../constants/ActionTypes';
import { NOTIFICATIONS_TYPE } from '../constants/Values';

/**
 *
 * @param {info|success|warning|error} type
 * @param {string|string[]} message
 * @param {object} options
 */

export const addNotification = (type, message, options = {}) => ({
  type: ADD_NOTIFICATION,
  payload: { type, message, options },
});

/**
 *
 * @param {string} message
 */
export const showInfoNotification = message => addNotification(NOTIFICATIONS_TYPE.INFO, message);

/**
 *
 * @param {string} message
 */
export const showSuccessNotification = message =>
  addNotification(NOTIFICATIONS_TYPE.SUCCESS, message);

/**
 *
 * @param {string} message
 */
export const showWarningNotification = message =>
  addNotification(NOTIFICATIONS_TYPE.WARNING, message);

/**
 *
 * @param {string} message
 */
export const showErrorNotification = message => addNotification(NOTIFICATIONS_TYPE.ERROR, message);

export const clearNotifications = () => ({
  type: CLEAR_NOTIFICATIONS,
});

/**
 *
 * @param {number} serverErrorCodeserverError
 */
export const setServerError = (serverErrorCode = null) => ({
  type: SET_SERVER_ERROR,
  payload: { serverErrorCode },
});

/**
 * @param {object} queryParamsList
 * @param {object} params
 * @param {object} pagination
 */
export const updateQuery = (pagination = {}, queryParamsList = {}, params = {}) => ({
  type: UPDATE_QUERY,
  payload: { pagination, queryParamsList, params },
});
